import { render, staticRenderFns } from "./HomepagePerformanceBoost.vue?vue&type=template&id=b5cd86bc&scoped=true&"
import script from "./HomepagePerformanceBoost.vue?vue&type=script&lang=ts&"
export * from "./HomepagePerformanceBoost.vue?vue&type=script&lang=ts&"
import style0 from "./HomepagePerformanceBoost.vue?vue&type=style&index=0&id=b5cd86bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cd86bc",
  null
  
)

export default component.exports